import { Vector3 } from "core/Maths/math.vector";
import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
/**
 * Block used to apply a cross product between 2 vectors
 */
export class RewardFlattenBlock extends RewardGraphNode {
    /**
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this.registerInput("vector", RewardGraphConnectionPointTypes.Vector3);
        this.registerInput("normal", RewardGraphConnectionPointTypes.Vector3);
        this.registerOutput("output", RewardGraphConnectionPointTypes.Vector3);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardFlattenBlock";
    }

    public get vector(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    public get normal(): RewardGraphConnectionPoint {
        return this._inputs[1];
    }

    /**
     * Gets the output component
     */
    public get output(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    protected override _buildBlock() {
        if (!this.vector.isConnected || !this.normal.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }

        this.output._storedFunction = (state) => {
            const normal = this.normal.getConnectedValue(state) as Vector3;
            const vector = this.vector.getConnectedValue(state) as Vector3;

            return vector.subtract( normal.scale(normal.normalize().dot( vector )) );
        };

        return this;
    }
}

RegisterClass("MELS.RewardFlattenBlock", RewardFlattenBlock);
